module.exports = __webpack_public_path__ + "assets/img/thumb-LJ-Hooker-Pillar-Page-Resource.026c8b58.jpg";